module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_B2B_MESSAGE.b81ad92d.svg";